<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include base.pug
    .content-wrappers.category-selector(v-if="!isEmpty || categoryOptions.length || $slots.default")
        slot
        //- .edit(v-if="edit")
        //- .preview(v-else)

        .preview(v-if="!isEmpty && categoryOptions.length")
            // wrap el-tag to bypass transition
            .categories
                el-tag(
                    v-for="category in getCategories(section)"
                    type="info"
                    :key="category.id"
                    effect="dark"
                ) {{ category.name }}

        .error(v-if="!categoryOptions.length")
            el-alert(type="warning" effect="dark" :title="$t('There are no event categories for this CMS!')")

    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Content')")
                    .tab-content
                        .content-wrapper
                            el-form-item(:label="$t('Categories')")
                                el-select.is-full-width.dark(
                                    placeholder=""
                                    v-model="categories"
                                    valueKey="id"
                                    effect="dark"
                                    multiple
                                )
                                    el-option(
                                        v-for="category in categoryOptions"
                                        :key="category.id" :label="category.name" :value="category"
                                        :disabled="category.disabled"
                                    )
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include settings.pug
        .drawer-footer
            include section-drawer-footer.pug

</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Category": "Kategorie",
        "Categories": "Kategorien",
        "There are no event categories for this CMS!": "Für dieses CMS gibt es keine Event-Kategorien!",
        "from": "ab",
        "to": "bis",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Tags": "Tags",
        "Select tags": "Tags auswählen",
        "Accessible by": "Zugänglich von",
        "e.g. 40px, 10%, 2em, ...": "z.B. 40px, 10%, 2em, ...",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Telefon",
        "Visible on":"Anzeigen auf",
        "Element is displayed on":"Inhaltselement <br> wird dargestellt auf"
    }
}
</i18n>

<script>

import _ from 'lodash'

import store from '@/store'
import { checkRestrictions } from '@/helpers'
import Section from './Section'

export default {
    name: 'Events',
    extends: Section,
    computed: {
        editable() {
            return checkRestrictions('ex:evnt');
        },
        isEmpty() {
            // let empty = !this.$slots.default
            let empty = true

            // if (empty && this.section.categories && this.section.categories.length) empty = false
            // if (empty && this.section.tags && this.section.tags.length) empty = false

            // if (empty && this.section.informations && this.section.informations.length) empty = false
            if (empty && this.section.eventCategories && this.section.eventCategories.length) empty = false
            // if (empty && this.section.shopCategories && this.section.shopCategories.length) empty = false
            // if (empty && this.section.products && this.section.products.length) empty = false

            // const contents = _.get(this.section, 'contents') || []
            // contents.forEach(content => {
            //     if (! empty) return
            //     if (content.addresses && content.addresses.length) empty = false
            //     if (content.images && content.images.length) empty = false
            //     if (content.media && content.media.length) empty = false
            //     if (content.title || content.sub_title || content.text) empty = false
            // })

            return empty
        },
        categories: {
            get() {
                const section = this.drawer.section || this.section
                return this.getCategories(section)
            },
            set(categories) {
                const section = this.drawer.section || this.section

                // const payload = {
                //     i: this.i,
                //     // p: this.p,
                //     s: this.s,
                //     categories
                // }
                // store.commit(`${this.module}/extensions/eventManager/form/sectionCategories`, payload)

                this.$set(section, 'eventCategories', categories);
            }
        },
        categoryOptions() {
            // const options = store.getters[`${this.module}/options`]
            return _.get(this.options, 'extensions.eventManager.category.items') || []
        },
    },
    methods: {
        getCategories(section) {
            return _.get(section, 'eventCategories') || []
        },
    }
}
</script>

<style lang="sass" scoped>
.viewports
    margin-right: 12px
    .el-tooltip
        margin: 0 3px
        color: #9ca3af
        .inner
            text-align: center
.preview
    .categories
        margin-bottom: 0
</style>
